'use strict';

module.exports = {
    handlePromoCodeSubmit: () => {
        if (window.recaptchaSiteKey) {
            const $form = $('.promo-code-form');
            $form.on('submit', function (e) {
                let ready = $form.find('input[name=recaptcharesponse]').length > 0;
                if (ready) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                // Check if Google reCaptcha is enabled, and check for the token.
                grecaptcha.ready(function () {
                    grecaptcha.execute(window.recaptchaSiteKey, { action: 'submit' }).then((token) => {
                        if (token) {
                            $('<input>').attr('type', 'hidden').attr('name', 'recaptcharesponse').attr('value', token).appendTo($form);
                            $form.trigger('submit');
                        } else {
                            window.location.href = window.errorRedirectURL;
                        }
                    });
                });
            });

            $form.on('cart:submit-promoCode:error cart:submit-promoCode:success', () => {
                $form.find('input[name=recaptcharesponse]').remove();
            });
        }
    },
};
